import { localize } from "utils/localizer";

const i18n = {
    accept: {
        en: "Accept",
        de: "Akzeptieren",
    },
    affectedEntries: {
        en: (x: number) => `${x} affected entries`,
        de: (x: number) => `${x} betroffene Einträge`,
    },
    aliasAccount: {
        en: "Alias Account",
        de: "Alias Account",
    },
    aliasAccounts: {
        en: "Alias accounts",
        de: "Alias-Accounts",
    },
    allowBookings: {
        en: "Allow bookings",
        de: "Darf Buchungen tätigen",
    },
    allowed: {
        en: "Allowed",
        de: "Erlaubt",
    },
    anErrorOccurred: {
        en: "An error occurred",
        de: "Ein Fehler ist aufgetreten",
    },
    apply: {
        en: "Apply",
        de: "Anwenden",
    },
    blocked: {
        en: "Blocked",
        de: "Blockiert",
    },
    bookings: {
        en: "Bookings",
        de: "Buchungen",
    },
    browseFile: {
        en: "Browse file",
        de: "Datei auswählen",
    },
    bulkEdit: {
        en: "Bulk Edit",
        de: "Stapelverarbeitung",
    },
    cancel: {
        en: "Cancel",
        de: "Abbrechen",
    },
    club: {
        en: "Location",
        de: "Sportstätte",
    },
    csvImport: {
        en: "Import from CSV file",
        de: "Import aus CSV-Datei",
    },
    date: {
        en: "Date",
        de: "Datum",
    },
    decline: {
        en: "Decline",
        de: "Ablehnen",
    },
    delete: {
        en: "Delete",
        de: "Löschen",
    },
    edit: {
        en: "Edit",
        de: "Ändern",
    },
    emailAddress: {
        en: "E-Mail Address",
        de: "E-Mail Adresse",
    },
    execute: {
        en: "Execute",
        de: "Durchführen",
    },
    export: {
        en: "Export",
        de: "Exportieren",
    },
    exportOwnerOnly: {
        en: "Export can be used by owner only",
        de: "Exportfunktion nur für Eigentümer verfügbar",
    },
    filter: {
        en: "Filter",
        de: "Filtern",
    },
    firstName: {
        en: "First Name",
        de: "Vorname",
    },
    import: {
        en: "Import",
        de: "Importieren",
    },
    importDesc: {
        en: "Upload a CSV file to automatically create PLAYSPORTS accounts for members. The columns for first name, last name and email address have to be specified. If multiple members have the same email address, a main account is created for the first occurrence and alias accounts for the other occurrences are created. If members are already registered in your location, no action is taken. If members are registered in another location, they will receive an invitation to join your location, too.",
        de: "PLAYSPORTS-Accounts von Mitgliedern können automatisch über eine CSV-Datei angelegt werden. Dazu müssen die Felder für Vorname, Nachname und E-Mail angegeben werden. Wenn mehrere Mitglieder mit derselben E-Mail Adresse hinterlegt sind, wird automatisch ein Haupt-Account für das erste Vorkommen und Alias-Accounts für weitere Vorkommen erstellt. Falls ein Mitglied bereits in deiner Sportstätte bei PLAYSPORTS registriert ist, wird keine Aktion vollzogen. Falls ein Mitglied bereits in einer anderen Sportstätte bei PLAYSPORTS registriert ist, so verknüpfen wir den Account zusätzlich mit deiner Sportstätte.",
    },
    importSuccess: {
        en: (num: number) => `Successfully imported ${num} ${num === 1 ? "user" : "users"}`,
        de: (num: number) => `${num} ${num === 1 ? "Mitglied" : "Mitglieder"} erfolgreich importiert`,
    },
    lastName: {
        en: "Last Name",
        de: "Nachname",
    },
    members: {
        en: "Members",
        de: "Mitglieder",
    },
    membershipRequests: {
        en: "Membership Requests",
        de: "Mitgliedsanfragen",
    },
    nameChanges: {
        en: "Name Changes",
        de: "Namensänderungen",
    },
    newName: {
        en: "New Name",
        de: "Neuer Name",
    },
    originalName: {
        en: "Original Name",
        de: "Ursprünglicher Name",
    },
    query: {
        en: "Query",
        de: "Suchanfrage",
    },
    reset: {
        en: "Reset",
        de: "Zurücksetzen",
    },
    selectColumn: {
        en: "Select column",
        de: "Feld auswählen",
    },
    singleImport: {
        en: "Single import",
        de: "Einzelimport",
    },
    status: {
        en: "Status",
        de: "Status",
    },
    userRolesB2C: {
        en: {
            standard: "Standard",
            trainer: "Coach",
            groundskeeper: "Groundskeeper",
            admin: "Admin",
            owner: "Owner",
        },
        de: {
            standard: "Standard",
            trainer: "Trainer",
            groundskeeper: "Platzwart",
            admin: "Admin",
            owner: "Eigentümer",
        },
    },
    userRolesB2B: {
        en: {
            standard: "Standard",
            trainer: "Company-Hero",
            admin: "Admin",
            owner: "Owner",
        },
        de: {
            standard: "Standard",
            trainer: "Company-Hero",
            admin: "Admin",
            owner: "Eigentümer",
        },
    },
    insufficientNumberOfSeatsInCompanyForImportError: {
        en: (associated: any) => `Your company has purchased an insufficient number of seats for this import. Your import includes ${associated.numNewMembers} new member(s), you have purchased ${associated.allowedNumMembers} seat(s) and there are currently ${associated.currentNumMembers} member(s).`,
        de: (associated: any) => `Dein Unternehmen hat nicht genügend Plätze für diesen Import bezahlt. Dein Import beinhaltet ${associated.numNewMembers} neue Mitglieder, du hast für ${associated.allowedNumMembers} Plätze bezahlt und es gibt aktuell ${associated.currentNumMembers} Mitglieder.`,
    },
    site: {
        en: "Site",
        de: "Standort",
    },
    confirm: {
        en: "Confirm",
        de: "Bestätigen",
    },
    alert: {
        en: "Alert",
        de: "Achtung",
    },
};

export default localize(i18n);
